import React from 'react';
import { Picture } from 'react-responsive-picture';

import Logo from './logo.svg';

import './styles.scss';

class Finish extends React.Component {
    render() {
        return (
          <div className="finish">
            <div className="finish__content">
              <img src={Logo}  alt="Капсула mail.ru" className="start__logo" />
              <h2 className="finish__title">Ура, мы закончили розыгрыш!</h2>
              <div className="finish__img">
                <Picture
                  sources = {[
                    {
                      srcSet: `./static/media/finish/finish-320.png 1x, ./static/media/finish/finish-320@2x.png 2x `,
                      media: "(max-width: 767px)",
                    },
                    {
                      srcSet: `./static/media/finish/finish-768.png 1x, ./static/media/finish/finish-768@2x.png 2x `,
                      media: "(min-width: 768px) and (max-width: 1919px)",
                    },
                    {
                      srcSet: `./static/media/finish/finish-1920.png 1x, ./static/media/finish/finish-1920@2x.png 2x `,
                      media: "(min-width: 1920px) and (max-width: 2559px)",
                    },
                    {
                      srcSet: `./static/media/finish/finish-2500.png 1x, ./static/media/finish/finish-2500@2x.png 2x `,
                      media: "(min-width: 2560px)",
                    }
                  ]}
                  src={`./static/media/finish/finish-2500.png`}
                  alt=""
                />
              </div>
          		<p className="finish__text">Нажмите на кнопку, чтобы узнать, кто победил</p>
              <a href="https://vk.com/wall-183540171_1909" target="_blank" rel="noopener noreferrer" className="button -orange -size-l">Узнать результаты</a>
              <div className="finish__rules">
                <a href="./static/files/Pravila_Aktsii_Ko_Dnyu_Druzei_774_Final.pdf" target="_blank" rel="noopener noreferrer" data-xray-click="terms_link">Правила акции</a>
              </div>
            </div>
        	</div>
        )
    }
}

export default Finish;
